export default __webpack_public_path__ + "fd54bd06523575a51ee3f55aac92cac0.png";